import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiUser, FiLogOut, FiHome, FiFileText, FiUsers, FiCheckSquare, FiHeart, FiMessageCircle } from 'react-icons/fi';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 導航欄 */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            {/* 左側導航 */}
            <div className="flex flex-1 md:flex-initial">
              <div className="flex-shrink-0 flex items-center">
                <Link to="/" className="flex items-center space-x-2">
                  {/* Logo SVG - 空心愛心：上半紫色M框、下半黃色V框 */}
                  <div className="w-10 h-10 flex-shrink-0 hidden md:block">
                    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {/* 上半部 - 紫色M形邊框（中間向下形成M形） */}
                      <path 
                        d="M7 19C7 15.5 8.5 12.5 11 10.5C13 9 16 8.5 20 13C24 8.5 27 9 29 10.5C31.5 12.5 33 15.5 33 19C33 20.5 32.5 22 31.5 23.5" 
                        stroke="#8B5CF6" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        fill="none"
                      />
                      {/* 下半部 - 黃色V形邊框 */}
                      <path 
                        d="M8.5 23.5C9.5 25 11 26.5 13 28C15.5 30 17.5 32 20 35C22.5 32 24.5 30 27 28C29 26.5 30.5 25 31.5 23.5" 
                        stroke="#EAB308" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  </div>
                  {/* 文字部分 */}
                  <span className="text-xl font-bold">
                    <span className="text-yellow-500">Vote</span>
                    <span className="bg-gradient-to-r from-yellow-500 to-purple-500 bg-clip-text text-transparent">2</span>
                    <span className="text-purple-500">Match</span>
                  </span>
                </Link>
              </div>
              
              <div className="ml-2 md:ml-6 flex flex-1 md:flex-initial md:justify-start">
                {user ? (
                  <>
                    <Link
                      to="/profile"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/profile') 
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiUser className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">個人資料</span>
                    </Link>
                    
                    <Link
                      to="/voting"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/voting') || isActive('/voting/create') || isActive('/voting/my') || isActive('/voting/favorites')
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiCheckSquare className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">投票</span>
                    </Link>
                    
                    <Link
                      to="/matching"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/matching') 
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiHeart className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">配對</span>
                    </Link>
                    
                    <Link
                      to="/friends"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/friends') || location.pathname.startsWith('/chat')
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiMessageCircle className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">聊天</span>
                    </Link>
                  </>
                ) : (
                  <>
                    <Link
                      to="/"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/') 
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiHome className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">首頁</span>
                    </Link>
                    
                    <Link
                      to="/voting"
                      className={`flex-1 md:flex-initial inline-flex items-center justify-center px-3 md:px-4 pt-1 pb-1 border-b-2 text-base md:text-sm font-medium ${
                        isActive('/voting') || location.pathname.startsWith('/voting/')
                          ? 'border-yellow-400 text-gray-900' 
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      }`}
                    >
                      <FiCheckSquare className="md:mr-1 text-lg md:text-base" />
                      <span className="hidden md:inline">投票廣場</span>
                    </Link>
                  </>
                )}
              </div>
            </div>

            {/* 右側使用者資訊 */}
            <div className="flex items-center">
              {user ? (
                <div className="flex items-center space-x-2 md:space-x-4">
                  <div className="text-sm text-gray-700 hidden md:block">
                    <span className="font-medium">{user.username}</span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="hidden md:inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <FiLogOut className="mr-1 text-base" />
                    <span>登出</span>
                  </button>
                </div>
              ) : (
                <div className="flex items-center space-x-2 md:space-x-4">
                  <Link
                    to="/login"
                    className="text-gray-500 hover:text-gray-700 px-3 md:px-3 py-2 rounded-md text-base md:text-sm font-medium"
                  >
                    登入
                  </Link>
                  <Link
                    to="/register"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 md:px-4 py-2 rounded-md text-base md:text-sm font-medium"
                  >
                    註冊
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>


      </nav>

      {/* 主要內容 */}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

export default Layout; 